import { createContext, useContext } from "react";

export type ListingAnalyticsContext = {
  trackShare(): Promise<void>;
  trackContactClick(): Promise<void>;
};

export const listingAnalyticsContext = createContext<ListingAnalyticsContext>({
  trackShare: async () => void 0,
  trackContactClick: async () => void 0,
});

export function useListingAnalytics() {
  const context = useContext(listingAnalyticsContext);
  return context;
}
